// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { QuestRoute } from '../_common/api/QuestRoutes';
import { generateId } from '../_common/api/utility';
import { useGlobalState } from '../_common/globalState/GlobalStateProvider';
import Loading from '../_common/Loading';
import LocationDropdown from './LocationDropdown';
import ProductCard from './ProductCard';
import { HamQuest } from '../../App';

const ItemsWrapper = styled.div`
    height: inherit;
    overflow-x: overlay;
    height: 100%;
`
const Items = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    height: calc(100% - 3.5em);
    width: fit-content;
    min-width: 100%;
`

const ItemList = ({ items, ...props }) => {
    const {
        state: {
            active_user,
        },
    } = useGlobalState();

    const { search } = useLocation();
    const location = new URLSearchParams(search);
    const [listItems, setListItems] = useState(items);
    const [shownItems, setShownItems] = useState(listItems);
    const [loc, setLoc] = useState([]);
    const [locFilter, setLocFilter] = useState(parseInt(location.get('location')) || active_user.forcedLocation || 0);

    useEffect(() => {
        HamQuest.get(QuestRoute.locations, { cache: 'force-cache' })
            .then((res) => setLoc(
                res.map(e => {
                    return {
                        label: e.city,
                        value: e.id
                    }
                }).filter(e => e.label)
            ))
        setListItems(items)
    }, [items])

    useEffect(() => {
        const items = listItems.filter(item =>
            !locFilter
                ? true
                : props.customFilter ? item[props.customFilter.key] === locFilter
                    : item.locations.length === 0 || item.locations.includes(locFilter)
        );

        setShownItems(
            items
                .sort((a, b) => b.price - a.price)
                .map(e =>
                    <ProductCard
                        key={generateId()}
                        id={generateId()}
                        title={e.name}
                        price={e.price}
                        color={`rgb(${e.logo.red}, ${e.logo.green}, ${e.logo.blue}, ${e.logo.alpha})`}
                        image={e.logo.imageIndex}
                        details={e.details}
                        item={e}
                    />
                ))

        const wrapper = document.getElementById('ItemWrapper')
        if (!wrapper) return;
        wrapper.scrollTo(0, 0);
    }, [locFilter, listItems]);

    return (
        <div style={{ height: '100%', minWidth: '100%', overflow: 'hidden' }} data-draggable={true}>
            {!props.disableLocFilter && <LocationDropdown locFilter={locFilter} setLocFilter={setLocFilter} customFilter={props.customFilter} />}
            <ItemsWrapper id='ItemWrapper'>
                <Items>
                    {!loc.length ? <Loading /> : shownItems}
                </Items>
            </ItemsWrapper>
        </div>
    );
}

export default ItemList;